import React from 'react';
import FadeIn from './ui/FadeIn';
import SafeIcon from '../common/SafeIcon';
import { FiLayout, FiBox, FiTruck } from 'react-icons/fi';

const steps = [
  { 
    icon: FiLayout, 
    title: "Browse & Select", 
    desc: "Browse our extensive design library and pick the vases that match your brand or upcoming occasions." 
  },
  { 
    icon: FiBox, 
    title: "Choose Quantity", 
    desc: "Order exactly what you need. Minimum order is just 4 vases, shipped safely in boxes of 4." 
  },
  { 
    icon: FiTruck, 
    title: "Fast Delivery", 
    desc: "We deliver locally in the West Valley or ship via UPS anywhere in the United States." 
  }
];

export default function HowItWorks() {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 md:px-12">
        <FadeIn className="text-center mb-16">
          <h2 className="font-heading text-4xl font-bold mb-4">How It Works</h2>
          <p className="text-gray-500 max-w-2xl mx-auto">Three simple steps to getting premium, custom-wrapped vases for your shop.</p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <FadeIn key={index} delay={index * 0.1} className="text-center group">
              <div className="w-20 h-20 mx-auto bg-warmWhite rounded-full flex items-center justify-center mb-6 text-sage group-hover:bg-sage group-hover:text-white transition-colors duration-300">
                <SafeIcon icon={step.icon} className="w-8 h-8" />
              </div>
              <h3 className="font-heading text-xl font-semibold mb-3">{step.title}</h3>
              <p className="text-gray-600 font-light leading-relaxed">{step.desc}</p>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}